import { Alert } from '@uswitch/spark'
import { UswPersonFill } from '@uswitch/spark-icons/usw'
import React, { useEffect, FC } from 'react'

import { getNoDealsLabelFromSlug } from '~/components/intent/slug'
import { usePageContext } from '~/contexts/page-context'
import { track } from '~/utils/tracking'

import styles from './no-deals-message.module.css'

interface Props {
  setFilters: (filters: object) => void
  visible: boolean
}

const NoDealsMessage: FC<Props> = ({ setFilters, visible }) => {
  const { resetSlug, slug } = usePageContext()

  useEffect(() => {
    visible && track('Broadband - no deals available message', 'no results for address provided')
  }, [visible])

  if (!visible) return null

  const onClick = () => {
    if (resetSlug) resetSlug()
    setFilters({})
  }

  const dealLabel = getNoDealsLabelFromSlug(slug)

  return (
    <Alert className={styles.icon} icon={<UswPersonFill size={'24'} />} variant='error' title='No results found'>
      We don’t have any {dealLabel ? <strong>{dealLabel}</strong> : 'deals'} for you currently.{' '}
      <button className={styles.button} onClick={onClick}>
        See other available deals
      </button>
      .
    </Alert>
  )
}

export default NoDealsMessage
